import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=b9db7eec&scoped=true&"
import script from "./AddStaff.vue?vue&type=script&lang=js&"
export * from "./AddStaff.vue?vue&type=script&lang=js&"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=b9db7eec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db7eec",
  null
  
)

export default component.exports